<template>
  <div>
    <ib-charts-placeholder v-if="isMarketingElementsEmpty" />
    <el-tabs
      v-else
      v-model="activeTab"
      class="tabs"
    >
      <el-tab-pane
        :label="$t('timeline')"
        name="first"
        lazy
      >
        <div class="bg-white pt-4 pb-1">
          <marketing-budget-over-time v-if="activeTab === 'first'" chart-animations />
        </div>
      </el-tab-pane>

      <!-- Breakdown -->
      <el-tab-pane
        :label="$t('breakdown')"
        name="second"
        lazy
      >
        <div class="bg-white pt-4 pb-1">
          <distribution-of-marketing-budget v-if="activeTab === 'second'" chart-animations />
        </div>
      </el-tab-pane>

      <!-- Table -->
      <el-tab-pane
        :label="$t('table')"
        name="third"
        lazy
      >
        <div class="bg-white pt-4 pb-2">
          <marketing-budget-table />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import DistributionOfMarketingBudget from '@/views/Home/StoryMode/FinancialPlan/Components/Expenses/MarketingCost/DistributionOfMarketingBudget.vue'
import MarketingBudgetOverTime from '@/views/Home/StoryMode/FinancialPlan/Components/Expenses/MarketingCost/MarketingBudgetOverTime.vue'
import MarketingBudgetTable from '@/views/Home/StoryMode/Forecast/MarketingBudget/Tables/MarketingBudgetTable.vue'

export default {
  name: 'MarketingCostsTabs',

  components: { MarketingBudgetTable, DistributionOfMarketingBudget, MarketingBudgetOverTime },

  data () {
    return {
      activeTab: 'first'
    }
  },

  computed: {
    ...mapState(['idea']),

    isMarketingElementsEmpty () {
      return this.idea.storyMode.forecast.marketingBudget.marketingElements.length === 0
    }
  }
}
</script>

<style scoped lang="scss">
.tabs {
  ::v-deep {
    .el-tabs__content {
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 0 0 8px 8px;
    }
  }
}
</style>
